import { Injectable } from "@angular/core";

import { APIs } from "@azm/core/constants/api-names";
import { HttpService } from "@azm/core/services/http";
import { ILoginResponse } from "@azm/core/interfaces/auth";

import {
	ILoginBusinessPayload,
	IValidateBusinessPayload,
	IValidateFirmResponse,
	ISummaryResponse,
	IRegisterBusinessPayload,
	IRegisterBusinessResponse,
} from "@azm/features/auth/interfaces/business";

@Injectable({
	providedIn: "root",
})
export class BusinessService extends HttpService {
	protected override get controllerName(): string {
		return "business/";
	}

	login(body: ILoginBusinessPayload) {
		return this.post<ILoginResponse>({
			APIName: `${APIs.business.login}`,
			body,
		});
	}

	validateFirm(body: IValidateBusinessPayload) {
		return this.post<IValidateFirmResponse>({
			APIName: `${APIs.business.validateFirm}`,
			body,
		});
	}

	validateAttorney(body: IValidateBusinessPayload) {
		return this.post<IValidateFirmResponse>({
			APIName: `${APIs.business.validateAttorney}`,
			body,
		});
	}

	getSummary(userId: string) {
		return this.get<ISummaryResponse>({
			APIName: `${APIs.business.summary}?UserId=${encodeURIComponent(userId)}`,
		});
	}

	register(body: IRegisterBusinessPayload) {
		return this.post<IRegisterBusinessResponse>({
			APIName: `${APIs.business.register}`,
			body,
		});
	}
}
